import { useMemo } from "react";
import {
  InputLeftElement,
  InputRightElement,
  NumberInput as ChakraNumberInput,
  NumberInputField,
  Button,
} from "@chakra-ui/react";

export default function NumberInput(props) {
  const {
    endAdornment,
    startAdornment,
    placeholder,
    fieldProps,
    _input,
    _endAdornment,
  } = props;
  return (
    <ChakraNumberInput
      borderRadius="16px !important"
      variant="filled"
      {...props}
      pos="relative"
    >
      {startAdornment && (
        <InputLeftElement
          right="20px"
          h="100%"
          color="#A0A3BD"
          // p="28px 50px"
          w="70px"
          children={startAdornment}
        />
      )}
      <NumberInputField
        errorBorderColor="pink"
        _invalid={{ shadow: "0 0 0 2px var(--errorColor)" }}
        borderRadius="16px"
        minH="56px"
        bg="#EFF0F7"
        border="1px solid transparent"
        borderColor="gray.200"
        placeholder={placeholder}
        _focus={{
          borderColor: "#06C344",
          boxShadow: "0 0 0 3px #06C3448f",
        }}
        pl={startAdornment ? "60px" : "1rem"}
        {...fieldProps}
        {..._input}
      />

      {endAdornment && (
        <InputRightElement
          pos="absolute"
          right="20px"
          h="100%"
          color="#A0A3BD"
          // p="28px 50px"
          children={endAdornment}
          {..._endAdornment}
        />
      )}
    </ChakraNumberInput>
  );
}

export function NumberInputWithMax(props) {
  const { onMax, isMaxDisabled, isLoading, _container, _input, ...xprops } =
    props;

  const adornment = useMemo(() => {
    const map = {
      true: {
        // _input: {
        //   pr: "4.8rem",
        // },
        _endAdornment: {
          right: "10px",
          w: "56px",
        },
        endAdornment: (
          <Button
            isLoading={isLoading}
            disabled={isLoading || isMaxDisabled}
            px="12px"
            bg="var(--primary)"
            color="white"
            _focus={{
              shadow: "0 0 0 3px var(--focusColor)",
            }}
            onClick={onMax}
          >
            Max
          </Button>
        ),
      },
      false: {},
    };

    return map[String(!!onMax)];
  }, [onMax, isMaxDisabled, isLoading]);

  return (
    <NumberInput
      minH="100%"
      // px=".8rem !important"
      // borderRadius="0px 16px 16px 0px"
      // _focus={{ shadow: "none", borderColor: "transparent" }}
      // _container={{
      //   flex: 0.71,
      //   ml: "0 !important",
      // }}

      ml="0 !important"
      _input={{
        px: ".8rem",
        pr: !!onMax ? "4.3rem" : ".8rem",
        // minH: "58px",
        // borderWidth: "0",
        // borderColor: "transparent",
        // _focus: {
        //   shadow: "none",
        // },

        ..._input,
      }}
      {...adornment}
      {..._container}
      {...xprops}
    />
  );
}
